import axios from "axios";
import { getHashedString } from "@/utils/helperFunctions/getHashedString";
import { BASE_URL } from "../../config/api_collection";
import { getHeaderData } from "../crm";
import { AFFILIATE_STAGE, WEB } from "../../constants/variables";

const AFFILIATE_URL = `${BASE_URL}/api/ibe/affiliate`;

type SaveAffiliatesImpressionArgus = {
  fullUrlRequested: string;
  timestamp: number;
  affiliateId: string;
  redirectId: string;
  campaign?:string;
  medium?: string;
  stage: string;
};

type AffiliatesPostImpression = {
  impressionId: string;
  redirectId: string;
  price: string;
  currency: string;
  timestamp: number;
};

export const saveAffiliatesImpression = async ({
  fullUrlRequested,
  timestamp,
  affiliateId,
  redirectId,
  campaign,
  medium,
  stage
}: SaveAffiliatesImpressionArgus): Promise<string> => {
  try {
    const hashInput = fullUrlRequested + timestamp;
    const hashedString = getHashedString(hashInput);
    const apiEndpoints = `${AFFILIATE_URL}/impression`;
    const headerObject = await getHeaderData();
    headerObject["Content-Type"] = "application/json";
    headerObject.Accept = "application/json";
    headerObject["x-idempotency-key"] = hashedString; // "hash of (url+epoch at first call)"
    const response = await axios.post(
      apiEndpoints,
      {
        channel: WEB,
        deeplink: fullUrlRequested,
        affiliateId,
        timestamp,
        redirectId,
        campaign,
        medium,
        stage
      },
      { headers: headerObject }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error in Affiliates impression:", error);
    return "";
  }
};

export const saveAffiliatesPostImpression = async ({
  timestamp,
  impressionId,
  redirectId,
  price,
  currency
}: AffiliatesPostImpression): Promise<string> => {
  try {
   const apiEndpoints = `${AFFILIATE_URL}/post-impression`;
    const headerObject = await getHeaderData();
    headerObject["Content-Type"] = "application/json";
    headerObject.Accept = "application/json";

    const stage = AFFILIATE_STAGE.BOOKING_PAGE;

    const response = await axios.post(
      apiEndpoints,
      {
        channel: WEB,
        timestamp,
        impressionId,
        redirectId,
        price,
        currency,
        stage
      },
      { headers: headerObject }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error in Affiliates impression:", error);
    return "";
  }
};